/**
 * Costs Manage Tab Component
 *
 * Displays pricepoints filtered by type using MetadataTable.
 * The pricepoint type filter is passed from the parent CostsPage.
 *
 * Features (all metadata-driven):
 * - Data fetching from /pricepoints/search with pricepointTypeId filter
 * - Pagination, sorting, filtering
 * - Presets, search, advanced filters
 * - Column customization
 * - Detail drawer (create/edit/view)
 * - Lifecycle actions
 *
 * Note: The deletedAt filter comes from pricepoint.yaml schema's _meta.base_filters,
 * which allows the "Show Deleted" toggle to work in MetadataTable UI.
 */

import { Empty } from 'antd'
import { MetadataTable } from '@/components/MetadataTable'
import type { PricepointTypeKey } from '@/types/pricepoint.types'

interface CostsManageTabProps {
  /** The selected pricepoint type to filter by */
  selectedType: PricepointTypeKey | null
}

export function CostsManageTab({ selectedType }: CostsManageTabProps) {
  // Show empty state when no type is selected
  if (!selectedType) {
    return (
      <Empty
        description="Select a cost type from the sidebar to view pricepoints"
        style={{ marginTop: 64 }}
      />
    )
  }

  return (
    <MetadataTable
      endpoint="/pricepoints"
      useViewMetadata={true}
      baseFilters={[
        { key: 'pricepointTypeId', constraint_type: 'EQUAL', value: selectedType },
      ]}
      // Force remount when type changes to reset table state
      key={selectedType}
    />
  )
}
